import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const reservacionCuposSlice = createSlice({
    name: 'reservacion_cupo',
    initialState: {
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateReservacionCupo: (state, action) => {
            return {
                item: {},
                message: "",
                process: "",
                error: "",
            }
        },
        setReservacionCupo: (state, action) => {
            return {
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setProcess: (state, action) => {
            return {
                items: [],
                item: {},
                process: true,
                message: "",
                error: "",
            }
        },
        setMessage: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getReservacionCupoThunk = (ci_padre) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/reservacion_cupo/${ci_padre}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setReservacionCupo(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const reservarCupoThunk = (id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/reservacion_cupo/reservar_cupo/${id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};



export const { initialStateReservacionCupo,
    setReservacionCupo,
    setParent,
    setMessage,
    setError,
     } = reservacionCuposSlice.actions;

export default reservacionCuposSlice.reducer;